import _Vue from "vue";
import { Asdcom } from "@/asdcom/appservice.asdcom";
import store from "@/store";
import { StaffSignalrService } from "@/asdcom/sinalR/staff-signalr.service";
import SignalRAspNetCoreHelper from "@/lib/SignalRAspNetCoreHelper";
import { GlobalEventsService } from "@/asdcom/global-events-service";
import { CommonService } from "@/asdcom/commonservice.asdcom";
// import { LookupsServiceProxy } from "@/asdcom/apiproxy/apiproxy.Lookup";
// import { LookupItemDto } from "@/asdcom/apiproxy/apiproxy.dto";
// import { lookupService } from "dns";
// import { VcpOnlineOkServiceServiceProxy } from "@/asdcom/apiproxy/apiproxy.VcpOnlineOkService";
// import { ContactUsServiceServiceProxy } from "@/asdcom/apiproxy/apiproxy.ContactUsService";
// import { CustomerUserProfileServiceProxy } from "@/asdcom/apiproxy/apiproxy.CustomerUserProfile";
// import { NotificationServiceProxy } from "@/asdcom/apiproxy/apiproxy.Notification";
// import { ProfileAddressDtoState } from "@/asdcom/apiproxy/apiproxy.dto.vcponlineok";
// import { ProfileServiceProxy } from "@/asdcom/apiproxy/apiproxy.Profile";
// import { PublicContactRequestsServiceProxy } from "@/asdcom/apiproxy/apiproxy.PublicContactRequests";
// import { SessionServiceProxy } from "@/asdcom/apiproxy/apiproxy.Session";
// import { TokenAuthServiceProxy } from "@/asdcom/apiproxy/apiproxy.TokenAuth";

export function AppServicesPlugin<AppServicesPluginOptions>(Vue: typeof _Vue, options?: AppServicesPluginOptions): void {
    Vue.prototype.$appsvs = new AppServices(options);
}

export class AppServicesPluginOptions {
}

export class AppServices {
    public account: Asdcom.AccountAppService;
    public contactUs: Asdcom.ContactUsAppService;
    public customerUser: Asdcom.CustomerUserProfileAppService;
    public lookups: Asdcom.LookupsAppService;
    public notifications: Asdcom.NotificationAppService;
    public profile: Asdcom.ProfileAppService;
    public publicContact: Asdcom.PublicContactRequestsAppService;
    public session: Asdcom.SessionAppService;
    public tokenAuth: Asdcom.TokenAuthAppService;
    public vcpOnlineOk: Asdcom.VcpOnlineOkService;
    public vcpOnlineOkStaff: Asdcom.VcpOnlineOkStaffService;
    public staffVpBox: Asdcom.StaffVpBoxService;
    public staffSignalrService: StaffSignalrService;
    public common: CommonService;
    public globalEventsService: GlobalEventsService;

    constructor(options?: AppServicesPluginOptions) {
        this.account = new Asdcom.AccountAppService();
        this.contactUs = new Asdcom.ContactUsAppService();
        this.customerUser = new Asdcom.CustomerUserProfileAppService();
        this.lookups = new Asdcom.LookupsAppService();
        this.notifications = new Asdcom.NotificationAppService();
        this.profile = new Asdcom.ProfileAppService();
        this.publicContact = new Asdcom.PublicContactRequestsAppService();
        this.session = new Asdcom.SessionAppService();
        this.tokenAuth = new Asdcom.TokenAuthAppService();
        this.vcpOnlineOk = new Asdcom.VcpOnlineOkService();
        this.vcpOnlineOkStaff = new Asdcom.VcpOnlineOkStaffService();
        this.staffVpBox = new Asdcom.StaffVpBoxService();
        this.staffSignalrService = new StaffSignalrService();
        this.globalEventsService = new GlobalEventsService();
        this.common = new CommonService();
    }

    get isLoading():boolean|undefined{
        return store.state.asdcom.app.loading;
    }


}